import { SearchPageShell, SearchDocView } from "@/pages/search/SearchDocLayout";
import {
  KnowledgeExplore,
  KnowledgeHeroNav,
  KnowledgePager,
} from "@/pages/search/KnowledgeChrome";
import { useCapabilitiesReturn } from "@/lib/knowledgeReturn";

export default function GuideDocLayout({
  item,
  related = [],
  neighbors = {},
  testId = "guide-detail",
  kicker = "GUIDE",
  preview = false,
}) {
  const fromCapabilities = useCapabilitiesReturn();
  const title = item?.title || "가이드";
  const guides = (related || []).filter((row) => (row.href || "").startsWith("/guides"));
  const portfolios = (related || []).filter((row) => (row.href || "").startsWith("/portfolio"));
  const explore = [
    { href: "/guides", label: "Guide 전체보기" },
    ...guides.slice(0, 3).map((row) => ({ href: row.href, label: `관련 Guide · ${row.label}` })),
    { href: "/capabilities", label: "관련 Capability" },
    ...portfolios.slice(0, 3).map((row) => ({ href: row.href, label: row.label || "관련 Portfolio" })),
    { href: "/", label: "홈" },
  ];
  return (
    <SearchPageShell testId={testId}>
      <KnowledgeHeroNav
        backHref={fromCapabilities ? "/capabilities" : "/guides"}
        backLabel={fromCapabilities ? "Capabilities" : "Guide"}
        crumbs={
          fromCapabilities
            ? [
                { href: "/", label: "홈" },
                { href: "/capabilities", label: "Capabilities" },
                { href: "/guides", label: "Guide" },
                { label: title },
              ]
            : [
                { href: "/", label: "홈" },
                { href: "/guides", label: "Guide" },
                { label: title },
              ]
        }
      />
      <SearchDocView
        item={item}
        related={related}
        kicker={kicker}
        preview={preview}
        hubPath="/guides"
        hubLabel="가이드"
        hideBreadcrumb
      />
      <KnowledgePager prev={neighbors.prev} next={neighbors.next} indexHref="/guides" indexLabel="Guide 전체보기" />
      <KnowledgeExplore
        heading="관련 콘텐츠"
        links={explore}
        contact
      />
    </SearchPageShell>
  );
}
